module.exports = __webpack_public_path__ + "img/marker-icon-2x-green.f1d1fa45.png";